import axiosPrivate from "./axiosPrivate";

export const getWalletTransactions = async ({ wallet_number_or_uuid }) => {
  const res = await axiosPrivate.get(`customers/wallet-transactions?page=1&items_per_page=20&wallet_number_or_uuid=${wallet_number_or_uuid}`);
  return res.data;
};

export async function getExchangeRate({ from, to, amount }) {
  const response = await axiosPrivate.post('currencies/exchange/rate', {
    base_currency: from,
    quote_currency: to,
    exchange_amount: amount
  });
  return response.data;
}